import React, { FC, lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from './routes';
import styled from 'styled-components';
import { Loader } from 'UI';
import { getPreservedSearchRoute } from '@hooks';

const LoaderPage = lazy(async () => await import('modules/loader'));
const ResultPage = lazy(async () => await import('modules/result'));
const SurveyLayout = lazy(async () => await import('modules/survey/layout'));
const Step = lazy(async () => await import('modules/survey/Step'));
const StartPage = lazy(async () => await import('modules/startPage'));
const Contacts = lazy(async () => await import('modules/contacts'));
const Payment = lazy(async () => await import('modules/payment'));
const Paywall = lazy(async () => await import('modules/paywall'));
const ActivationInstructions = lazy(async () => await import('modules/activationInstructions'));

const Container = styled.div`
	position: relative;
	max-width: ${({ theme }) => theme.containerWidth};
	margin: 0 auto;
	height: 100%;
`;

export const Router: FC = () => {
	return (
		<Container>
			<Suspense fallback={<Loader />}>
				<Routes>
					<Route path={ROUTES.CONTACTS} element={<Contacts />} />
					<Route path={ROUTES.HOME} element={<StartPage />} />
					<Route path={ROUTES.SURVEY} element={<SurveyLayout />}>
						<Route path={`${ROUTES.SURVEY}/:id`} element={<Step />} />
					</Route>
					{/* <Route path={ROUTES.PAYMENT} element={<Payment />} /> */}
					<Route path={ROUTES.LOADER} element={<LoaderPage />} />
					<Route path={ROUTES.RESULT} element={<ResultPage />} />
					<Route
						path={ROUTES.PAYWALL}
						element={
							<>
								<Paywall />
								<Payment />
							</>
						}
					/>
					<Route path={ROUTES.ACTIVATION_INSTRUCTIONS} element={<ActivationInstructions />} />
					<Route
						path={ROUTES.PLAN}
						element={<Navigate to={getPreservedSearchRoute(ROUTES.SURVEY)} replace />}
					/>
					<Route
						path={ROUTES.PAY}
						element={<Navigate to={getPreservedSearchRoute(ROUTES.PAYWALL)} replace />}
					/>
					<Route
						path='*'
						element={<Navigate to={getPreservedSearchRoute(ROUTES.SURVEY)} replace />}
					/>
				</Routes>
			</Suspense>
		</Container>
	);
};
